export const getFormErrorMessage = (type: string, field: string): string => {
  switch (type) {
    case 'pattern':
      return `Please enter a valid ${field}`;
    case 'required':
      return `Please enter your ${field}`;
    default:
      return `Error: ${type}`;
  }
};
